import { earthSciencePreviewEnabled } from '@/lib/earthScience';

export const EARTH_SCIENCE_TOOL_IDS = [
  'solar-system-seasons',
  'earth-moon-sun-cycles',
  'plate-tectonics-hazards',
  'rock-cycle-minerals',
  'carbon-cycle-systems',
  'weather-systems-evidence',
  'water-catchments-groundwater',
  'geological-time-fossils',
  'natural-hazards-risk',
  'ocean-circulation-climate',
  'universe-redshift-scale',
  'topographic-maps-slope',
  'geological-cross-sections',
  'earth-observation-vegetation',
  'field-transect-evidence',
  'mineral-resources-recovery',
  'atmosphere-lapse-stability',
  'biodiversity-quadrat-sampling',
  'resource-stock-sustainability',
  'environmental-time-series-uncertainty',
  'seismic-wave-distance',
  'radiometric-dating-half-life',
  'storm-hydrograph-response',
  'soil-infiltration-erosion',
  'groundwater-flow-gradient',
  'earthquake-epicentre-triangulation',
  'unconformity-missing-time',
  'catchment-water-balance',
  'climate-anomaly-baseline',
  'satellite-vegetation-change',
  'earthquake-catalogue-patterns',
  'rainfall-station-timeseries',
  'streamflow-station-hydrograph',
  'fractional-cover-timeseries',
  'surface-geology-data-evidence',
] as const;

export type EarthScienceToolId = (typeof EARTH_SCIENCE_TOOL_IDS)[number];

export const EARTH_SCIENCE_TOOLS_ENABLED =
  import.meta.env.DEV || earthSciencePreviewEnabled();

export function isEarthScienceToolId(value: string | undefined): value is EarthScienceToolId {
  return EARTH_SCIENCE_TOOL_IDS.some((toolId) => toolId === value);
}
